function Spinner() {
  return <span className='loading loading-spinner loading-lg text-primary-600'></span>;
}

export default Spinner;
